<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭">
    <efs-md-company-price-list-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></efs-md-company-price-list-form>
  </j-modal>
</template>

<script>

  import EfsMdCompanyPriceListForm from './EfsMdCompanyPriceListForm'
  export default {
    name: 'EfsMdCompanyPriceListModal',
    components: {
      EfsMdCompanyPriceListForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      setCompanyCode(){},
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
          if(this.$t('button.edit') === this.title){
            this.$refs.realForm.isMmCodeDisabled = true;
          }
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.realForm.isMmCodeDisabled = false;
      },
      handleOk () {
        this.$refs.realForm.handleOk();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>